export default __webpack_public_path__ + "static/media/classify2.ed702950.png";